/**
 * 银行卡选择组件
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2025, all rights reserved. Essa.cn
 */
import React from 'react';
import { Modal,Spin } from "antd";
import Lang from "@/components/Lang/Lang";
import AddBank from "@/components/AddBank/addBank";
import HttpServerAction from '@/api/httpServer.action';
import "./index.less"
const { confirm } = Modal;

class BankCardSelector extends React.Component {
    static defaultProps = {
        buyerId: "",      // 采购商ID
    };
    constructor(props) {
        super(props);
        this.state = {
            // 银行列表
            bankList: []
        }
    }
    deleteCard(bank){
        confirm({
            title: Lang({id: 'ShiFouQueRenShanChu',default:'是否确认删除'}),
            onOk:()=> {
                this.handleDelete(bank);
            },
            onCancel:()=> {
            },
        });
    }

    handleDelete(bank){
        this.loading(true);
        HttpServerAction.postHttpAction('/service/mg/buyer/bank/delete', {
            id: bank.id,
        }).then((resp) => {
            if (resp.data && resp.data.success){
                this.getBankList();
            }
            this.loading(false);
        }).catch((err) => {
            this.loading(false);
        });
    }
    getBankList(){
        const {buyerId} = this.props;
        if (buyerId) {
            this.loading(true);
            HttpServerAction.postHttpAction('/service/mg/buyer/bank/list', {
                buyerId: buyerId
            }).then((resp) => {
                this.loading(false);
                if (resp.data && resp.data.success && resp.data.valid) {
                    this.setState({
                        bankList: resp.data.models || []
                    });
                }
            }).catch((err) => {
                this.loading(false);
            });
        }
    }
    changeBank(curBank={}){
        this.setState({curBank:curBank});
        if(this.props.changeBank){
            this.props.changeBank(curBank);
        }
    }
    // 格式化银行卡号，四个数字间隔一空格，中间8个数字为星号
    formatBankNo(bankNo) {
        if (!bankNo || bankNo.length < 13) {
            return bankNo || "-";
        }
        // 格式：1234 **** **** 5678，四个数字间隔一空格，中间8位用*代替
        const prefix = bankNo.substring(0, 4);
        const suffix = bankNo.substring(bankNo.length - 4);
        return `${prefix} **** **** ${suffix}`;
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
    componentDidMount() {
        this.getBankList();
    }

    render() {
        const { buyerId,showRequire=true} = this.props;
        const {bankList=[], curBank={},loading=false } = this.state;
        return (
            <Spin spinning={loading}>
                <div className={"mt_20 flex-item-ver-center"}>
                    {showRequire&&<span className={"color-red2 mr_4"}>*</span>}
                    <span className={"font_16 black89 fw_700 flex-1"}>
                        {Lang({id: "XuanZeShouKuanYinXingKa", default: "选择收款银行卡"})}
                    </span>
                </div> 
                <AddBank buyerId={buyerId} refreshPage={() => this.getBankList()} />
                {bankList && bankList.length > 0 ? (
                    <div className={"mt_12 flex-item bankWrap"}>
                        {bankList.map((bank, inx) => (
                            <div
                                className={`flex-item-between itemBank${curBank.id == bank.id ? ' onBank' : ''}`}
                                key={'bank_' + inx}
                            >
                                <div className={"flex-1"} onClick={() => this.changeBank(bank)}>
                                    {bank.bankLogoUrl&&<div><img src={bank.bankLogoUrl} height={24} /></div>}
                                    <div className={"mt_4"}>
                                        {bank.bankName}
                                    </div>
                                    <div className={"mt_8"}>
                                        {this.formatBankNo(bank.bankNo)}
                                    </div>
                                </div>
                                <div className={"rightIcon"}>
                                    <span className={"topIcon cursor-p"} onClick={() => this.deleteCard(bank)}>
                                        <i className="ri-delete-bin-2-line"></i>
                                    </span>
                                    <AddBank 
                                        className={"bottomIcon cursor-p"} 
                                        row={bank} 
                                        buyerId={buyerId} 
                                        refreshPage={() => this.getBankList()}
                                    >
                                        <i className="ri-edit-2-line"></i>
                                    </AddBank>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </Spin>
        );
    }
}

export default BankCardSelector;

